import client, { PaginatedResponse } from '@/utils/client'
import urls from '@/utils/urls'

var defaultState = {}

export const mutations = {
}

export const getters = {
}

export const actions = {
  createPlaylist (ctx, data) {
    if (data.id) throw new Error('playlist id is defined, can\'t create anew')
    return client.post(urls.playlist.list(), data).then(response => response.data)
  },
  updatePlaylist (ctx, data) {
    if (!data.id) throw new Error('playlist id undefined, can\'t update playlist')
    return client.patch(urls.playlist.detail(data.id), data).then(response => response.data)
  },
  deletePlaylist (ctx, id) {
    return client.delete(urls.playlist.detail(id)).then(response => response.data)
  },
  listPlaylists (ctx, filter) {
    return client
      .get(urls.playlist.list(), {
        params: filter
      })
      .then(response => new PaginatedResponse(response.data))
  },
  getPlaylist (ctx, {id}) {
    return client.get(urls.playlist.detail(id)).then(response => response.data)
  },
  async appendPlaylistSong (ctx, {playlistId, songId}) {
    try {
      const response = await client.post(urls.playlist.appendSong(playlistId), {song_id: songId})
      return response.data
    } catch (e) {
      if (e.response && e.response.data && e.response.data.song_id) {
        throw new Error(e.response.data.song_id)
      } else {
        throw new Error('Can\'t add to playlist')
      }
    }
  },
  removePlaylistSong (ctx, {playlistId, songId}) {
    return client.post(urls.playlist.removeSong(playlistId), {song_id: songId}).then(response => response.data)
  },
  async addToHistory ({rootGetters, dispatch}, songId) {
    const history = rootGetters['profile/currentUser'].default_playlists.history

    const result = await client.post(urls.playlist.prependSong(history.id), {song_id: songId})
    history.video_ids = result.data.video_ids
  },
  async followPlaylist ({dispatch}, playlistId) {
    await client.post(urls.playlist.follow(playlistId))
    return dispatch('profile/getCurrentUser', null, { root: true })
  },
  async unfollowPlaylist ({dispatch}, playlistId) {
    await client.post(urls.playlist.unfollow(playlistId))
    return dispatch('profile/getCurrentUser', null, { root: true })
  }
}

export default {
  namespaced: true,
  state: defaultState,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/playlist.js